import React from 'react';
import { Slide as SlideType } from '@/eventConfig/types.ts';
import { ConfirmDataEntryCheckbox } from '@/components/slides/DataSummary/components/ConfirmDataEntryCheckbox.tsx';
import { ConfigSlideId } from '@/eventConfig/types.ts';
import { useForm } from '@/form/useForm.ts';
import { shouldUseBirthdateManualFlow } from '@/components/slides/BirthdateGate/birthdateFlow.ts';

export const ConfirmDataEntryCheckboxZA = ({ slide }: { slide: SlideType }) => {
  const { getFieldValue } = useForm();
  const birthdateSlideId: ConfigSlideId = shouldUseBirthdateManualFlow({
    peselCheckResult: String(getFieldValue('peselCheckResult') ?? ''),
    pesel: String(getFieldValue('pesel') ?? ''),
    zaId: String(getFieldValue('za_id') ?? ''),
    birthdate: String(getFieldValue('birthdate') ?? ''),
  })
    ? 'birthdateManual'
    : 'birthdate';

  const slideIdsToValidate: ConfigSlideId[] = ['name', 'email', 'phone', 'address', birthdateSlideId, 'bmi', 'ancestry'];
  return <ConfirmDataEntryCheckbox slide={slide} slideIdsToValidate={slideIdsToValidate} />;
};
